import { queryUserWebsite, visitInfo, getMutil, behaviorInfo, getUserSite } from '@/api/index.js';
import { queryTotalBuyerCartList } from '@/api/buyCar.js';
import { getStorageSync, setStorageSync, clearStorageSync } from '@/utils/storage.js';
import { mobileProductDetailPath } from '@/utils/link/mobileProductDetail';

// 设置loginType
export const setLoginType = async companyId => {
	let isLogin = !!getStorageSync('cmdc_access_token_mobile');
	if (companyId) {
	}
	if (!isLogin) {
		setStorageSync('loginType', 1);
	} else {
		let userInfo = getStorageSync('user') || {};
		let res = null;
		if (userInfo && userInfo.websiteData) {
			res = userInfo.websiteData;
		} else {
			res = await queryUserWebsite();
			if (res.code == 200) {
				userInfo.websiteData = res;
				setStorageSync('user', userInfo);
			} else {
				setStorageSync('loginType', 1);
				return;
			}
		}
		let inItem = res.data.find(item => {
			return item.companyId == companyId;
		});
		if (inItem) {
			setStorageSync('loginType', 4);
		} else {
			let userInfo = getStorageSync('user') || {};
			if (userInfo && userInfo.merchantStatus) {
				setStorageSync('loginType', 2);
				//如果是第三方会员，判断用户审核状态是否是通过
				// if (this.userInfo.merchantStatus != 3) {
				// 	this.$message.error('第三方用户未审核通过')
				// 	uni.navigateTo({
				// 		url: '/login'
				// 	})
				//   }
			} else {
				setStorageSync('loginType', 3);
			}
		}
	}
};

// 获取站点信息
export const getMutils = async codes => {
	let res = null;
	if (codes && codes.f) {
		res = await getMutil(codes);
		setStorageSync('getMutilAll', res.data);
	} else {
		res = await getMutil();
	}

	if (res.code == 200) {
		if (codes == 1) {
		} else {
			res.data.unshift({
				companyName: '首页',
				companyId: 1,
				companyCode: '',
				websiteName: '首页',
			});
		}

		setStorageSync('getMutil', res.data);
		return res;
	}
};

// 通过companyCode 获取站点信息
export const getCompanyInfo = async (companyCode, companyName, companyId) => {
	let res = null;
	if (!(getStorageSync('getMutilAll') && Array.isArray(getStorageSync('getMutilAll')))) {
		let mu = await getMutils({ f: true });
		res = mu.data;
	} else {
		res = getStorageSync('getMutilAll');
	}
	let list = {};
	if (res) {
		res.map(item => {
			if (companyCode) {
				if (item.companyCode == companyCode) {
					list = item;
				}
			} else if (companyName) {
				if (item.companyName == companyName) {
					list = item;
				}
			} else if (companyId) {
				if (item.companyId == companyId) {
					list = item;
				}
			}
		});
	}

	return list;
};
export const clearLocalStorage = () => {
	let openId = null;
	if (!!getStorageSync('user_openCode')) {
		openId = getStorageSync('user_openCode');
	}
	clearStorageSync();
	if (openId) {
		setStorageSync('user_openCode', openId);
	}
};

// 埋点日志
export const setVisitInfo = module => {
	visitInfo({
		module: module,
	});
};

// 跳转到详情页
export const toProductDetail = item => {
	if (item.invalidSign === 1) return; // 失效商品不能跳转
	getCompanyInfo(item.filialeCode || item.filialecode).then(res => {
		item.companyId = res.companyId;
		const path = mobileProductDetailPath(item.companyId, item.productId || item.productid);
		if (path) navigateTo(path);
	});
};

// 埋点日志2
export const setBehaviorInfo = params => {
	behaviorInfo(params);
};
// 获取子站被动
export const getUserSitess = params => {
	let isLogin = !!getStorageSync('cmdc_access_token_mobile');
	if (isLogin) {
		getUserSite(params);
	}
};
